<template>
    <div class="mozali-login mozali-login--split">
        <aside class="mozali-login__showcase">
            <div class="mozali-login__showcase-brand">
                <img
                    :src="urlGenerator('/logo_format_black.png')"
                    alt="Mozali"
                    class="mozali-login__showcase-logo"
                >
            </div>

            <div class="mozali-login__showcase-main">
                <div class="mozali-login__illustration-wrap">
                    <img
                        :src="urlGenerator('/images/shift-banner.svg')"
                        :alt="$t('login_illustration_alt')"
                        class="mozali-login__illustration"
                    >
                </div>
                <h2 class="mozali-login__showcase-title">
                    {{ $t('login_showcase_title') }}
                </h2>
                <p class="mozali-login__showcase-text">
                    {{ $t('login_showcase_text') }}
                </p>
            </div>

            <div class="mozali-login__testimonial">
                <p class="mozali-login__testimonial-title">{{ $t('login_testimonial_title') }}</p>
                <p class="mozali-login__testimonial-text">
                    {{ $t('login_testimonial_text') }}
                </p>
                <p class="mozali-login__testimonial-meta">{{ $t('login_testimonial_author') }}</p>
            </div>
        </aside>

        <section class="mozali-login__auth-side">
            <form class="sign-in-sign-up-form mozali-login__form"
                  ref="form"
                  data-url="/admin/users/login"
                  action="store">
                <div class="mozali-login__brand text-center">
                    <img
                        :src="urlGenerator('/logo_format_black.png')"
                        alt="Mozali"
                        class="mozali-login__logo"
                    >
                </div>

                <p class="mozali-login__eyebrow">{{ $t('login_welcome_back') }}</p>
                <h3 class="mozali-login__title">{{ $t('login_continue_title') }}</h3>

                <div class="form-row">
                    <div class="form-group col-12 px-0">
                        <label for="login_email">{{ $t('email') }}</label>
                        <app-input id="login_email"
                                   type="email"
                                   v-model="login.email"
                                   :placeholder="$t('enter_your_email')"
                                   :required="true"/>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-12 px-0 mb-2">
                        <label for="login_password">{{ $t('password') }}</label>
                        <app-input id="login_password"
                                   type="password"
                                   v-model="login.password"
                                   :placeholder="$t('enter_your_password')"
                                   :required="true"/>
                    </div>
                </div>

                <div class="form-row" v-if="recaptchaEnable == 1">
                    <div class="form-group col-12 px-0">
                        <re-captcha :site-key="siteKey"></re-captcha>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 px-0 mb-2">
                        <a :href="urlGenerator('/forget-password')"
                           class="mozali-login__forgot d-inline-flex align-items-center">
                            {{ $t('forgot_password') }}
                        </a>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-12 px-0 mb-2">
                        <app-load-more :preloader="preloader"
                                       :label="$t('login')"
                                       type="submit"
                                       class-name="btn btn-primary btn-block text-center mozali-login__submit"
                                       @submit="submit"/>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 px-0">
                        <p class="mozali-login__copy text-center">
                            &copy; {{ currentYear }} -
                            <a
                                :href="mozaliSiteUrl"
                                class="mozali-login__copy-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.mozali.com
                            </a>
                        </p>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {},
        props: {
            siteKey: String,
            recaptchaEnable: {},
        },
        data() {
            return {
                urlGenerator,
                mozaliSiteUrl: 'https://www.mozali.com',
                login: {email: '', password: ''},
            };
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        },
        methods: {
            submit() {
                this.save(this.login);
            },
            afterSuccess(res) {
                window.location = res.data;
            }
        }
    }
</script>
